/* Qik Joe — motion
   One entrance rhythm for the whole theme: a 14px rise over 450ms with a
   60ms stagger across siblings. The CSS owns the animation; this file only
   decides when it runs and what index each element gets.

   Elements opt in with [data-reveal]. Siblings inside [data-reveal-group]
   are staggered in DOM order.

   If prefers-reduced-motion is set we never create an observer at all — the
   CSS already leaves those elements visible. */

(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function reveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!items.length) return;

    if (REDUCED.matches || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }

    // Stagger index is per group, so a section further down the page does not
    // inherit a two-second delay from the number of items above it.
    var groups = scope.querySelectorAll('[data-reveal-group]');
    for (var g = 0; g < groups.length; g++) {
      var kids = groups[g].querySelectorAll(':scope > [data-reveal]');
      for (var k = 0; k < kids.length; k++) {
        kids[k].style.setProperty('--reveal-i', String(k));
      }
    }

    /* Anything already on screen at load is revealed immediately rather than
       waiting to be observed. Two reasons: the hero should never depend on an
       observer callback arriving, and a browser that has throttled or delayed
       delivery (a background tab, a prerender, a page opened hidden) would
       otherwise leave the top of the page blank. */
    var vh = window.innerHeight || document.documentElement.clientHeight;

    // No viewport height at all means the document has not been laid out yet.
    // Nothing can be positioned against a viewport of zero, so reveal
    // everything rather than deferring the whole page to an observer that may
    // not deliver until the tab is looked at.
    if (!vh) {
      for (var z = 0; z < items.length; z++) items[z].classList.add('is-in');
      return;
    }

    var pending = [];
    for (var v = 0; v < items.length; v++) {
      var box = items[v].getBoundingClientRect();
      // Only `top` is tested. A page that has not been painted yet — opened in
      // a background tab, prerendered, restored hidden — reports every rect as
      // zero, and a bottom > 0 test would then send the hero to the observer
      // and leave it invisible until the tab is looked at. Revealing something
      // that turns out to be just above the fold costs nothing.
      if (box.top < vh) items[v].classList.add('is-in');
      else pending.push(items[v]);
    }
    if (!pending.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        if (!entries[e].isIntersecting) continue;
        entries[e].target.classList.add('is-in');
        io.unobserve(entries[e].target);
      }
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    for (var n = 0; n < pending.length; n++) io.observe(pending[n]);
  }

  document.addEventListener('DOMContentLoaded', function () { reveal(); });

  // The theme editor swaps section markup in place without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
  });

  // If the visitor turns reduced motion on mid-session, stop hiding things.
  if (REDUCED.addEventListener) {
    REDUCED.addEventListener('change', function () {
      if (REDUCED.matches) {
        var pending = document.querySelectorAll('[data-reveal]:not(.is-in)');
        for (var i = 0; i < pending.length; i++) pending[i].classList.add('is-in');
      }
    });
  }
})();
